var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09967 5.98795C7.46533 5.2407 8.53036 5.24066 8.89608 5.98788L10.4933 9.25111L14.0753 9.77545C14.8934 9.89521 15.221 10.8996 14.6308 11.4787L12.0357 14.025L12.6481 17.6216C12.7873 18.4396 11.9274 19.0615 11.1941 18.6731L7.99816 16.9801L4.80504 18.673C4.07214 19.0616 3.21207 18.4402 3.3507 17.6224L3.96046 14.025L1.36773 11.4783C0.778065 10.8991 1.10573 9.89527 1.92353 9.77547L5.50286 9.25114L7.09967 5.98795Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.4a74b12c2104e990d7bc927ef0801cf5.svg";
export { ForwardRef as ReactComponent };